import { render, staticRenderFns } from "./Profile_no_FB.vue?vue&type=template&id=1b7791af&scoped=true&"
import script from "./Profile_no_FB.vue?vue&type=script&lang=js&"
export * from "./Profile_no_FB.vue?vue&type=script&lang=js&"
import style0 from "./Profile_no_FB.vue?vue&type=style&index=0&id=1b7791af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7791af",
  null
  
)

export default component.exports